import { call, put, takeEvery } from 'redux-saga/effects';
import { actions } from '../../utils/constants';

import history from '../../history';
import routes from '../../utils/routes';

import {
    fetchTemplateTest,
    updateTemplateTest,
    saveQuestionsTemplateTest,
    deleteQuestionsTemplateTest,
    fetchQuestionsTemplateTest,
} from '../../utils/common-functions';

function* asyncFetchTemplateTest({ payload: { testId } }) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const response = yield call(fetchTemplateTest, { testId });
        const responseQuestions = yield call(fetchQuestionsTemplateTest, {
            testId,
        });

        yield put({
            type: actions.CHANGE_TEMPLATE_TEST_TO_MANAGE,
            payload: {
                template_test: response.data,
                questions: responseQuestions.data.template_questions,
            },
        });

        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: 'Não foi possível listar os detalhes do teste',
            },
        });
    }
}

function* asyncUpdateTemplateTest({
    payload: {
        testId,
        labelTest,
        maxDuration,
        minOptions,
        maxOptions,
        percentual,
        amountQuestions,
        questionsAddeds,
        questionsRemoveds,
    },
}) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const data = {
            label: labelTest,
            questions_per_test: amountQuestions,
            min_options: minOptions,
            max_options: maxOptions,
            max_duration: maxDuration,
            approval_percent: percentual,
        };

        if (questionsAddeds && questionsAddeds.length > 0) {
            yield call(saveQuestionsTemplateTest, {
                testId,
                data: {
                    questions: questionsAddeds,
                },
            });
        }

        if (questionsRemoveds && questionsRemoveds.length > 0) {
            yield call(deleteQuestionsTemplateTest, {
                testId,
                data: {
                    questions: questionsRemoveds,
                },
            });
        }

        yield call(updateTemplateTest, { testId, data });

        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        history.push(routes.TEMPLATE_TESTS);
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: err.response.data.error_description,
            },
        });
    }
}

export default function* manageTemplateTest() {
    yield takeEvery(
        actions.ASYNC_FETCH_TEMPLATE_TEST_TO_MANAGE,
        asyncFetchTemplateTest,
    );
    yield takeEvery(
        actions.ASYNC_UPDATE_TEMPLATE_TEST,
        asyncUpdateTemplateTest,
    );
}



// WEBPACK FOOTER //
// ./src/components/manage-template-test/manage-template-test.saga.js